import type { IPageTheme } from "./PageThemeContext"

// Add pages to this file that do not have the default dark nav and footer
// The footer and the nav are either dark or light (boolean)
// Outside of that the bgColorClass and bgHexColor will come from the designer.
// The bgHexColor is needed since some components need hex value instead of class, ie animations, etc.
// The default PageTheme is set in components/page-theme/PageThemeContext.tsx
// There is another file that is handling some context stuff and it is way more complex than this.
// This works for the nav and footer and doesn't show a flash of the wrong color before it renders
// the correct theme due to the way it's set up.
// Do not refactor this into AppContext.ts

const PageThemeData: IPageTheme[] = [
  // uncomment or update careers pages here when we go live with the new careers pages
  {
    location: "/careers/all-jobs",
    dark: false,
    bgColorClass: "bg-blue-2.5",
    bgColorHex: "#F5FBFF",
    bgColorClassFooter: "bg-blue-2.5",
    bgColorHexFooter: "#F5FBFF",
  },
  {
    location: "/careers/early-careers",
    dark: false,
    bgColorClass: "bg-blue-5",
    bgColorHex: "#e5f8ff",
    bgColorClassFooter: "bg-blue-5",
    bgColorHexFooter: "#e5f8ff",
  },
  {
    location: "/careers/locations",
    dark: false,
    bgColorClass: "bg-blue-5",
    bgColorHex: "#e5f8ff",
    bgColorClassFooter: "bg-blue-15",
    bgColorHexFooter: "#b3e5ff",
  },
  {
    location: "/careers/ripplelife",
    dark: false,
    bgColorClass: "bg-blue-5",
    bgColorHex: "#e5f8ff",
    bgColorClassFooter: "bg-blue-15",
    bgColorHexFooter: "#b3e5ff",
  },
  {
    location: "/careers/engineering",
    dark: false,
    bgColorClass: "bg-blue-5",
    bgColorHex: "#e5f8ff",
    bgColorClassFooter: "bg-blue-10",
    bgColorHexFooter: "#ccefff",
  },
  {
    location: "/careers",
    dark: false,
    bgColorClass: "bg-blue-5",
    bgColorHex: "#e5f8ff",
    bgColorClassFooter: "bg-blue-5",
    bgColorHexFooter: "#e5f8ff",
  },
  {
    location: "/impact/impact-report",
    dark: false,
    bgColorClass: "bg-gray-2.5",
    bgColorHex: "#fafafa",
    bgColorClassFooter: "bg-blue-2.5",
    bgColorHexFooter: "#F5FBFF",
  },
]

export default PageThemeData
